import { environment as RootEnvironment } from "../../../../env";
import { IEnvironmentConfig } from "../../../../libs/shared";

export const environment: IEnvironmentConfig = {
  production: false,
  WEGLOT_API_KEY: "",
  ...RootEnvironment,
};
